import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth';
import general from './modules/general';
import order from './modules/order';
import user from './modules/user';

Vue.use(Vuex)

const store = new Vuex.Store(
    {
        state: {},
        //strict: true, // TO DO: Remove this when deploying for PROD
        getters: {},
        actions: {},
        mutations: {},
        modules: {
            auth: {
                namespaced: true,
                state: auth.state,
                mutations: auth.mutations,
                getters: auth.getters,
                actions: auth.actions,
            },

            general: {
                namespaced: true,
                state: general.state,
                actions: general.actions,
                mutations: general.mutations,
                getters: general.getters,
            },

            order: {
                namespaced: true,
                state: order.state,
                actions: order.actions,
                mutations: order.mutations,
                getters: order.getters,
            },

            user: {
                namespaced: true,
                state: user.state,
                mutations: user.mutations,
                getters: user.getters,
                actions: user.actions,
            },
        }
    });

export default store;
